import { isHeartBeatRequestMessage } from '../../messages/FromWorkerMessageTypes';
import { createHeartBeatResponseMessage } from '../../messages/ToWorkerMessages';
import { createSharedWorker } from './createSharedWorker';
export const GENERIC_WORKER_ERROR = 'Error From WorkerScript';
export const connectSharedWorkerPort = ({
  url,
  workerName,
  onMessage,
  onMessageError,
  onWorkerError,
  version
}) => {
  const {
    worker,
    error
  } = createSharedWorker({
    name: workerName,
    url
  });
  if (!worker || !worker.port || error) {
    throw error || new Error('SharedWorker was not created or port is not available');
  }
  worker.onerror = onWorkerError;
  worker.port.onmessage = event => {
    if (event && event.data && isHeartBeatRequestMessage(event.data)) {
      worker.port.postMessage(createHeartBeatResponseMessage({
        name: workerName,
        requestId: event.data.id,
        version
      }));
      return;
    }
    onMessage(event);
  };
  worker.port.onmessageerror = messageErrorEvent => {
    const messageData = messageErrorEvent && messageErrorEvent.data ? messageErrorEvent.data : {};
    onMessageError(new Error(`Message Error in Shared Worker Port`), {
      messageData
    });
  };
  return worker;
};